import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { Select } from '@ngxs/store';
import { Adresa, Adresa2, DrzavaResponse, KatalogInstitucijaClient } from 'app/api/iop-katalog-institucija-api-reference';
import { KucniBroj, NaseljenoMesto, Opstina, Ulica } from 'app/models/features/rgz/rgz.model';
import { SifarniciState } from 'app/root-store/sifarnici/codebook.state';
import { Sifarnici } from 'app/root-store/sifarnici/codebooks.model';
import { RgzService } from 'app/services/rgz.service';
import {
  validateDrzava,
  validateKucniBroj,
  validateNaseljenoMesto,
  validateOpstinu,
  validateUlica
} from 'app/shared/helpers/custom-validators';
import { Observable, Subscription } from 'rxjs';

const nePostojiUlicaUSifarnikuItem = {
  ulicaId: '0',
  maticniBroj: '0',
  nazivCirilica: "Не постоји улица у шифарнику",
  nazivLatinica: 'Ne postoji ulica u sifarniku'
}

const nePostojiKucniBrojUSifarnikuItem = {
  brojId: '0',
  broj: "Не постоји кућни број у шифарнику",
  brojLatinica: "Ne postoji kucni broj u sifarniku"
}


@Component({
  selector: 'app-adresa',
  templateUrl: './adresa.component.html',
  styleUrls: ['./adresa.component.scss']
})
export class AdresaComponent implements OnInit, OnChanges, OnDestroy {
  // @Select(SifarniciState.opstineIzRGZ) opstine$: Observable<Opstina[]>;
  @Select(SifarniciState.sifarnici) sifarnici$: Observable<Sifarnici>;

  @Input() pregledPodataka: boolean = false;
  @Input() izmena: boolean = false;
  @Input() prosledjenaAdresa: Adresa;
  @Input() jeAdresaZaOJ: boolean = false;
  @Input() uzeoAdresuOdOrgana: boolean = false;

  @Output() istaAdresaKaoAdresaOrgana = new EventEmitter<boolean>();

  translatePrefix: string = "features.katalogOrgana.pretraga.";
  subscriptions: Subscription[] = [];
  organi: string[] = ["MUP", "APR"];

  opstine: Opstina[] = null;
  filtriraneOpstine: Opstina[] = [];
  selektovanaOpstina: Opstina;

  naseljenaMesta: NaseljenoMesto[];
  filtriranaMesta: NaseljenoMesto[] = [];
  selektovanoMesto: NaseljenoMesto;

  ulice: Ulica[];
  filtriraneUlice: Ulica[] = [];
  selektovanaUlica: Ulica;

  kucniBrojevi: KucniBroj[];
  filtriraniKucniBrojevi: KucniBroj[] = [];
  selektovanKucniBroj: KucniBroj;

  drzave: DrzavaResponse[] = null;
  filtriraneDrzave: DrzavaResponse[] = [];
  selektovanaDrzava: DrzavaResponse;

  form: FormGroup;

  constructor(
    private fb: FormBuilder,
    private rgzService: RgzService,
    private katalogInstitucijaService: KatalogInstitucijaClient
  ) { }

  async ngOnChanges(changes: SimpleChanges) {
    if (!changes.prosledjenaAdresa.firstChange) {
      await this.buildForm();
    }
  }

  async ngOnInit() {
    this.inizijalizujSifarnike();
  }

  async inizijalizujSifarnike() {
    // this.subscriptions.push(this.opstine$.subscribe(async res => {
    //   this.opstine = res;
    //   this.filtriraneOpstine = res;

    //   this.subscriptions.push(this.sifarnici$.subscribe(async sifarnici => {
    //     if (sifarnici?.drzave) {
    //       this.drzave = sifarnici.drzave;
    //       this.filtriraneDrzave = sifarnici.drzave;
    //       await this.buildForm();
    //     }
    //   }));
    // }));
  }

  async buildForm() {
    let disbaleControl = this.prosledjenaAdresa.drzavaSifra && this.prosledjenaAdresa.drzavaSifra != 'SRB';

    this.form = this.fb.group({
      tekstualnaAdresa: new FormControl<string>({ value: this.prosledjenaAdresa.tekstualnaAdresa, disabled: true }),
      drzava: new FormControl<string>({ value: this.mapirajDrzavu(), disabled: !this.jeAdresaZaOJ }),
      opstina: new FormControl<string>({ value: this.mapirajOpstinu(), disabled: disbaleControl }),
      naseljenoMesto: new FormControl<string>(await this.mapirajMesto()),
      ulica: new FormControl<string>(await this.mapirajUlicu()),
      ulicaVanSifarnika: new FormControl<string>(this.prosledjenaAdresa.ulicaVanSifarnika),
      kucniBroj: new FormControl<string>(await this.mapirajKucniBroj()),
      kucniBrojVanSifarnika: new FormControl<string>(this.prosledjenaAdresa.kucniBrojVanSifarnika),
      dodatak: new FormControl<string>({ value: this.prosledjenaAdresa.dodatak, disabled: disbaleControl }),
      ulaz: new FormControl<string>({ value: this.prosledjenaAdresa.ulaz, disabled: disbaleControl }),
      sprat: new FormControl<string>({ value: this.prosledjenaAdresa.sprat, disabled: disbaleControl }),
      stan: new FormControl<string>({ value: this.prosledjenaAdresa.stan, disabled: disbaleControl }),
      adresaNadredjenogOrgana: new FormControl<boolean>(this.uzeoAdresuOdOrgana)
    });

    this.postaviInicijalnoPoljaNaFormi();
  }

  postaviInicijalnoPoljaNaFormi() {
    this.opstina.setValidators(validateOpstinu(this.opstine));
    this.opstina.updateValueAndValidity();

    if (this.selektovanaDrzava?.countryAlphaCode3 == 'SRB') {
      this.opstina.enable();
    } else if (this.selektovanaDrzava != null) {
      this.tekstualnaAdresa.enable();
      this.opstina.disable();
    }

    if (this.jeAdresaZaOJ && this.adresaNadredjenogOrgana.value) {
      this.form.disable();
      this.adresaNadredjenogOrgana.enable();
    }

    if (this.pregledPodataka) {
      this.form.disable();
    } else if (this.izmena) {
      this.podesiFormuZaIzmenuPodataka();
    } else {
      this.naseljenoMesto.disable();
      this.ulica.disable();
      this.ulicaVanSifarnika.disable();
      this.kucniBroj.disable();
      this.kucniBrojVanSifarnika.disable();
    }
  }

  mapirajDrzavu() {
    if (!this.jeAdresaZaOJ || this.prosledjenaAdresa?.drzavaSifra == null || this.prosledjenaAdresa?.drzavaSifra == undefined) {
      this.selektovanaDrzava = this.drzave.find(d => d.countryAlphaCode3 == 'SRB');
    } else {
      this.selektovanaDrzava = this.drzave.find(d => d.countryAlphaCode3 == this.prosledjenaAdresa?.drzavaSifra);
    }
    return this.selektovanaDrzava?.cyrillicName ?? null;
  }

  mapirajOpstinu() {
    this.selektovanaOpstina = this.opstine?.find(opstina => opstina.maticniBroj.toString() == this.prosledjenaAdresa.opstinaSifra) ?? null;
    return this.selektovanaOpstina?.nazivCirilica ?? null;
  }

  async mapirajMesto() {
    await this.getNaseljenaMesta();
    this.selektovanoMesto = this.naseljenaMesta?.find(mesto => mesto.maticniBroj.toString() == this.prosledjenaAdresa.naseljenoMestoSifra) ?? null;
    return this.selektovanoMesto?.nazivCirilica ?? null;
  }

  async mapirajUlicu() {
    await this.getUlice();
    this.selektovanaUlica = this.ulice?.find(ulica => ulica.maticniBroj.toString() == this.prosledjenaAdresa.ulicaSifra) ?? null;
    return this.selektovanaUlica?.nazivCirilica ?? null;
  }

  async mapirajKucniBroj() {
    await this.getKucneBrojeve();
    this.selektovanKucniBroj = this.kucniBrojevi?.find(broj => broj.brojId.toString() == this.prosledjenaAdresa.kucniBrojSifra) ?? null;
    return this.selektovanKucniBroj?.broj ?? null;
  }

  dodajValidatoreZaIzmenu() {
    if (this.selektovanaDrzava?.countryAlphaCode3 != 'SRB') {
      this.tekstualnaAdresa.addValidators([Validators.required]);
      this.tekstualnaAdresa.updateValueAndValidity();
      this.tekstualnaAdresa.markAsTouched();
      return;
    }

    if (this.opstina.value) this.naseljenoMesto.enable();
    if (this.naseljenoMesto.value) this.ulica.enable();
    if (this.ulica.value) this.kucniBroj.enable();

    this.form.markAllAsTouched();

    this.opstina.addValidators([Validators.required])
    this.opstina.updateValueAndValidity()

    this.naseljenoMesto.addValidators([Validators.required])
    this.naseljenoMesto.updateValueAndValidity()

    this.ulica.addValidators([Validators.required])
    this.ulica.updateValueAndValidity()

    this.kucniBroj.addValidators([Validators.required]);
    this.kucniBroj.updateValueAndValidity();
  }

  dodajValidatoreZaUnos() {
    this.tekstualnaAdresa.removeValidators([Validators.required]);
    this.tekstualnaAdresa.updateValueAndValidity();

    this.opstina.removeValidators([Validators.required])
    this.opstina.updateValueAndValidity()

    this.naseljenoMesto.removeValidators([Validators.required])
    this.naseljenoMesto.updateValueAndValidity()

    this.ulica.removeValidators([Validators.required])
    this.ulica.updateValueAndValidity()

    this.kucniBroj.removeValidators([Validators.required]);
    this.kucniBroj.updateValueAndValidity();
  }

  napraviAdresu(adresaOrgana: Adresa | Adresa2): Adresa | Adresa2 {
    adresaOrgana.tekstualnaAdresa = this.tekstualnaAdresa.value?.trim() == "" ? null : this.tekstualnaAdresa.value;
    adresaOrgana.drzavaSifra = this.selektovanaDrzava?.countryAlphaCode3 ?? null;
    adresaOrgana.opstinaSifra = this.selektovanaOpstina?.maticniBroj?.toString() ?? null;
    adresaOrgana.naseljenoMestoSifra = this.selektovanoMesto?.maticniBroj?.toString() ?? null;
    adresaOrgana.ulicaSifra = this.selektovanaUlica?.maticniBroj?.toString() ?? null;
    adresaOrgana.ulicaVanSifarnika = this.ulicaVanSifarnika.value?.trim() == "" ? null : this.ulicaVanSifarnika.value;
    adresaOrgana.kucniBrojSifra = this.selektovanKucniBroj?.brojId?.toString() ?? null;
    adresaOrgana.kucniBrojVanSifarnika = this.kucniBrojVanSifarnika.value?.trim() == "" ? null : this.kucniBrojVanSifarnika.value;
    adresaOrgana.dodatak = this.dodatak.value?.trim() == "" ? null : this.dodatak.value;
    adresaOrgana.ulaz = this.ulaz.value?.trim() == "" ? null : this.ulaz.value;
    adresaOrgana.sprat = this.sprat.value?.trim() == "" ? null : this.sprat.value;
    adresaOrgana.stan = this.stan.value?.trim() == "" ? null : this.stan.value;

    if (adresaOrgana instanceof Adresa2) {
      adresaOrgana.id = this.prosledjenaAdresa.id;
    }
    return adresaOrgana;
  }

  podesiFormuZaIzmenuPodataka() {
    if (!this.naseljenoMesto.value) this.naseljenoMesto.disable();
    if (!this.ulica.value) this.ulica.disable();
    if (!this.ulicaVanSifarnika.value) this.ulicaVanSifarnika.disable();
    if (!this.kucniBroj.value) this.kucniBroj.disable();
    if (!this.kucniBrojVanSifarnika.value) this.kucniBrojVanSifarnika.disable();
  }

  napraviTekstualnuiAdresu() {
    let ulica = '';
    let kucnibroj = '';
    let opstina = this.opstina.value ?? '';
    let mesto = this.naseljenoMesto.value ?? '';

    if (this.selektovanaOpstina) opstina += ",";
    if (this.selektovanoMesto) mesto += ",";

    if (this.selektovanaUlica) {
      ulica = this.selektovanaUlica.maticniBroj == nePostojiUlicaUSifarnikuItem.maticniBroj ?
        this.ulicaVanSifarnika.value : this.ulica.value;
      ulica += ",";
    }

    if (this.selektovanKucniBroj) {
      kucnibroj = this.selektovanKucniBroj.brojId == nePostojiKucniBrojUSifarnikuItem.brojId ?
        this.kucniBrojVanSifarnika.value ?? '' : this.kucniBroj.value;
    }

    let adresa = `${opstina} ${mesto} ${ulica} ${kucnibroj}`;
    return adresa.trim() == '' ? null : adresa;
  }

  _filterDrzave() {
    if (this.drzava.value == "") this.selektovanaDrzava = null;
    let naziv = this.drzava.value;
    let filteredValues = this.drzave.filter(
      drzava => drzava.cyrillicName.toLowerCase().includes(naziv?.toLowerCase())
    );
    this.filtriraneDrzave = filteredValues;

    let validators: ValidatorFn[] = [validateDrzava(filteredValues)];
    this.drzava.clearValidators();
    this.drzava.updateValueAndValidity();
    this.drzava.setValidators(validators);
    this.drzava.updateValueAndValidity();

    this.opstina.disable();
    this.opstina.setValue(null);
    this.naseljenoMesto.disable();
    this.naseljenoMesto.setValue(null);
    this.ulica.disable();
    this.ulica.setValue(null);
    this.kucniBroj.disable();
    this.kucniBroj.setValue(null);

    this.ulicaVanSifarnika.disable();
    this.ulicaVanSifarnika.setValue(null);
    this.kucniBrojVanSifarnika.disable();
    this.kucniBrojVanSifarnika.setValue(null);

    this.dodatak.disable();
    this.dodatak.setValue(null);
    this.ulaz.disable();
    this.ulaz.setValue(null);
    this.sprat.disable();
    this.sprat.setValue(null);
    this.stan.disable();
    this.stan.setValue(null);

    this.tekstualnaAdresa.disable();
    this.tekstualnaAdresa.setValue(null);


    this.selektovanaDrzava = null;
    this.selektovanaOpstina = null;
    this.selektovanoMesto = null;
    this.selektovanaUlica = null;
    this.selektovanKucniBroj = null;
  }

  setDrzavu(drzava: DrzavaResponse) {
    this.selektovanaDrzava = drzava;
    if (this.selektovanaDrzava.countryAlphaCode3 == 'SRB') {
      this.opstina.enable();
      this.dodatak.enable();
      this.ulaz.enable();
      this.sprat.enable();
      this.stan.enable();
      this.tekstualnaAdresa.disable();
      this.tekstualnaAdresa.setValue(null);
    } else {
      this.form.reset();
      this.selektovanaOpstina = null;
      this.selektovanoMesto = null;
      this.selektovanaUlica = null;
      this.selektovanKucniBroj = null;
      this.form.disable();
      this.drzava.enable();
      this.drzava.setValue(this.selektovanaDrzava.cyrillicName);
      this.tekstualnaAdresa.enable();
      this.adresaNadredjenogOrgana.enable();
    }
    this.adresaNadredjenogOrgana.setValue(false)
  }

  async setOpstinu(opstina: Opstina) {
    this.selektovanaOpstina = opstina;

    this.naseljenoMesto.setValue(null);
    this.selektovanoMesto = null;

    this.ulica.setValue(null);
    this.selektovanaUlica = null;
    this.ulica.disable();
    this.ulicaVanSifarnika.setValue(null);
    this.ulicaVanSifarnika.disable();

    this.kucniBroj.setValue(null);
    this.selektovanKucniBroj = null;
    this.kucniBroj.disable();
    this.kucniBrojVanSifarnika.setValue(null);
    this.kucniBrojVanSifarnika.disable();

    this.tekstualnaAdresa.setValue(null);
    this.tekstualnaAdresa?.setValue(this.selektovanaOpstina.nazivCirilica);
    await this.getNaseljenaMesta();

    this.naseljenoMesto.enable();
  }

  async getNaseljenaMesta() {
    if (this.selektovanaOpstina?.maticniBroj) {
      this.naseljenaMesta = await this.rgzService.dajNaseljenaMesta(this.selektovanaOpstina?.maticniBroj);
      this.filtriranaMesta = this.naseljenaMesta;
    }
  }

  _filterOpstine() {
    let naziv = this.opstina.value;
    let filteredValues = this.opstine.filter(
      opstina => opstina.nazivCirilica.toLowerCase().includes(naziv?.toLowerCase())
    );

    this.filtriraneOpstine = filteredValues;
    this.naseljenoMesto.disable();
    this.naseljenoMesto.setValue(null);
    this.ulica.disable();
    this.ulica.setValue(null);
    this.kucniBroj.disable();
    this.kucniBroj.setValue(null);

    this.ulicaVanSifarnika.disable();
    this.ulicaVanSifarnika.setValue(null);
    this.kucniBrojVanSifarnika.disable();
    this.kucniBrojVanSifarnika.setValue(null);

    this.selektovanaOpstina = null;
    this.selektovanoMesto = null;
    this.selektovanaUlica = null;
    this.selektovanKucniBroj = null;

    this.tekstualnaAdresa.setValue(this.napraviTekstualnuiAdresu());
  }

  _filterMesta() {
    let naziv = this.naseljenoMesto.value;
    let filteredValues = this.naseljenaMesta.filter(
      mesto => mesto.nazivCirilica.toLowerCase().includes(naziv?.toLowerCase())
    );
    this.filtriranaMesta = filteredValues;

    this.ulica.disable();
    this.ulica.setValue(null);
    this.kucniBroj.disable();
    this.kucniBroj.setValue(null);

    this.ulicaVanSifarnika.disable();
    this.ulicaVanSifarnika.setValue(null);
    this.kucniBrojVanSifarnika.disable();
    this.kucniBrojVanSifarnika.setValue(null);

    this.naseljenoMesto.clearValidators();
    this.naseljenoMesto.setValidators(validateNaseljenoMesto(this.naseljenaMesta));
    this.naseljenoMesto.updateValueAndValidity();

    this.selektovanoMesto = null;
    this.selektovanaUlica = null;
    this.selektovanKucniBroj = null;
    this.tekstualnaAdresa.setValue(this.napraviTekstualnuiAdresu());
  }

  async setMesto(mesto: NaseljenoMesto) {
    this.selektovanoMesto = mesto;

    this.ulica.setValue(null);
    this.selektovanaUlica = null;
    this.ulicaVanSifarnika.setValue(null);
    this.ulicaVanSifarnika.disable();

    this.kucniBroj.setValue(null);
    this.selektovanKucniBroj = null;
    this.kucniBroj.disable();
    this.kucniBrojVanSifarnika.setValue(null);
    this.kucniBrojVanSifarnika.disable();

    this.tekstualnaAdresa?.setValue(this.tekstualnaAdresa.value.split(", ")[0] + ", " + this.selektovanoMesto.nazivCirilica);
    await this.getUlice();

    this.ulica.enable();
  }

  async getUlice() {
    if (this.selektovanoMesto?.maticniBroj) {
      this.ulice = await this.rgzService.dajUlice(this.selektovanoMesto?.maticniBroj);
      this.filtriraneUlice = this.ulice;
      this.filtriraneUlice?.unshift(nePostojiUlicaUSifarnikuItem)
    }
  }

  _filterUlice() {
    let naziv = this.ulica.value;
    let filteredValues = this.ulice.filter(
      ulica => ulica.nazivCirilica.toLowerCase().includes(naziv?.toLowerCase())
    );
    this.filtriraneUlice = filteredValues;

    this.kucniBroj.disable();
    this.kucniBroj.setValue(null);

    if (!this.filtriraneUlice.find(x => x.ulicaId == nePostojiUlicaUSifarnikuItem.ulicaId))
      this.filtriraneUlice?.unshift(nePostojiUlicaUSifarnikuItem)

    let validators: ValidatorFn[] = [validateUlica(filteredValues)];
    this.ulica.clearValidators();
    this.ulica.setValidators(validators);
    this.ulica.updateValueAndValidity();

    if (this.ulica.invalid) {
      this.kucniBroj.disable();
      this.kucniBroj.setValue(null);

      this.kucniBrojVanSifarnika.disable();
      this.kucniBrojVanSifarnika.setValue(null);

      this.ulicaVanSifarnika.disable();
      this.ulicaVanSifarnika.setValue(null);
    }


    this.selektovanaUlica = null;
    this.selektovanKucniBroj = null;
    this.tekstualnaAdresa.setValue(this.napraviTekstualnuiAdresu());
  }

  async setUlicu(ulica: Ulica) {
    this.selektovanaUlica = ulica;
    let splitovano = this.tekstualnaAdresa.value.split(", ");
    let opstinaIMesto = splitovano[0] + ", " + splitovano[1];

    this.kucniBroj.setValue(null);
    this.selektovanKucniBroj = null;

    if (this.selektovanaUlica.maticniBroj == nePostojiUlicaUSifarnikuItem.maticniBroj) {
      this.tekstualnaAdresa?.setValue(opstinaIMesto);

      this.ulicaVanSifarnika.enable();
      this.kucniBroj.disable();
      this.kucniBroj.setValue(nePostojiKucniBrojUSifarnikuItem.broj);
      this.selektovanKucniBroj = nePostojiKucniBrojUSifarnikuItem;

      this.ulicaVanSifarnika.addValidators([Validators.required]);
      this.ulicaVanSifarnika.updateValueAndValidity();
      this.kucniBrojVanSifarnika.addValidators([Validators.required]);
      this.kucniBrojVanSifarnika.updateValueAndValidity();
    } else {
      await this.getKucneBrojeve();
      this.tekstualnaAdresa?.setValue(opstinaIMesto + ", " + this.selektovanaUlica.nazivCirilica);

      this.kucniBroj.enable()
      this.ulicaVanSifarnika.disable();
      this.kucniBrojVanSifarnika.disable();

      this.ulicaVanSifarnika.clearValidators();
      this.ulicaVanSifarnika.updateValueAndValidity();
      this.ulicaVanSifarnika.setValue(null)
      this.kucniBrojVanSifarnika.clearValidators();
      this.kucniBrojVanSifarnika.updateValueAndValidity();
      this.kucniBrojVanSifarnika.setValue(null)
    }

  }

  postaviUlicuVanSifarnikaUTekstualnuAdresu() {
    this.tekstualnaAdresa.setValue(this.napraviTekstualnuiAdresu());
    if (this.ulicaVanSifarnika.value != null && this.ulicaVanSifarnika.value != "") {
      this.kucniBrojVanSifarnika.enable();
    } else {
      this.kucniBrojVanSifarnika.disable();
      this.kucniBrojVanSifarnika.setValue(null);
    }
  }

  async getKucneBrojeve() {
    this.kucniBrojevi = [];
    if (this.selektovanaUlica && this.selektovanaUlica?.maticniBroj != nePostojiUlicaUSifarnikuItem.maticniBroj) {
      this.kucniBrojevi = await this.rgzService.dajKucneBrojeve(this.selektovanaUlica?.maticniBroj);
    }

    this.kucniBrojevi.unshift(nePostojiKucniBrojUSifarnikuItem)
    this.filtriraniKucniBrojevi = this.kucniBrojevi;
  }

  _filterKucneBrojeve() {
    let naziv = this.kucniBroj.value;
    let filteredValues = this.kucniBrojevi.filter(
      broj => broj.broj.toLowerCase().includes(naziv?.toLowerCase())
    );
    this.filtriraniKucniBrojevi = filteredValues;

    if (!this.filtriraniKucniBrojevi.find(x => x.brojId == nePostojiKucniBrojUSifarnikuItem.brojId))
      this.filtriraniKucniBrojevi?.unshift(nePostojiKucniBrojUSifarnikuItem);

    let validators: ValidatorFn[] = [validateKucniBroj(filteredValues)];
    this.kucniBroj.clearValidators();
    this.kucniBroj.setValidators(validators);
    this.kucniBroj.updateValueAndValidity();

    if (this.kucniBroj.invalid) {
      this.kucniBrojVanSifarnika.disable();
      this.kucniBrojVanSifarnika.setValue(null);
    }

    this.selektovanKucniBroj = null;
    this.tekstualnaAdresa.setValue(this.napraviTekstualnuiAdresu());
  }

  async setKucniBroj(broj: KucniBroj) {
    this.selektovanKucniBroj = broj;
    let splitovano = this.tekstualnaAdresa.value.split(", ");
    let opstinaМestoIUlica = splitovano[0] + ", " + splitovano[1] + ", " + splitovano[2];


    if (this.selektovanKucniBroj.brojId == nePostojiKucniBrojUSifarnikuItem.brojId) {
      this.tekstualnaAdresa?.setValue(opstinaМestoIUlica);
      this.kucniBrojVanSifarnika.enable();
      this.kucniBrojVanSifarnika.addValidators([Validators.required]);
      this.kucniBrojVanSifarnika.updateValueAndValidity();
    } else {
      this.tekstualnaAdresa?.setValue(opstinaМestoIUlica + ", " + this.selektovanKucniBroj.broj);
      this.kucniBrojVanSifarnika.disable();
      this.kucniBrojVanSifarnika.clearValidators();
      this.kucniBrojVanSifarnika.updateValueAndValidity();
      this.kucniBrojVanSifarnika.setValue(null);
    }
  }

  postaviKucniBrojVanSifarnikaUTekstualnuAdresu() {
    this.tekstualnaAdresa.setValue(this.napraviTekstualnuiAdresu());
  }

  postaviAdresuNadleznogOrgana(checked) {
    this.istaAdresaKaoAdresaOrgana.emit(checked);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => {
      sub.unsubscribe();
    });
  }

  get tekstualnaAdresa() {
    return this.form.get("tekstualnaAdresa");
  }
  get drzava() {
    return this.form.get("drzava");
  }
  get opstina() {
    return this.form.get("opstina");
  }
  get naseljenoMesto() {
    return this.form.get("naseljenoMesto");
  }
  get ulica() {
    return this.form.get("ulica");
  }
  get ulicaVanSifarnika() {
    return this.form.get("ulicaVanSifarnika");
  }
  get kucniBroj() {
    return this.form.get("kucniBroj");
  }
  get kucniBrojVanSifarnika() {
    return this.form.get("kucniBrojVanSifarnika");
  }
  get dodatak() {
    return this.form.get("dodatak");
  }
  get ulaz() {
    return this.form.get("ulaz");
  }
  get sprat() {
    return this.form.get("sprat");
  }
  get stan() {
    return this.form.get("stan");
  }
  get adresaNadredjenogOrgana() {
    return this.form.get("adresaNadredjenogOrgana");
  }
}
